import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RegulatoryOffering from "@/pages/RegulatoryOffering";

export const Route = createFileRoute("/en/services/regulatory-affairs/scientific-advice")({
  head: () => buildRouteHead("/en/services/regulatory-affairs/scientific-advice"),
  component: RegulatoryOffering,
});

